(function () {
  'use strict';

  angular.module('datepicker').controller('DatepickerCtrl', DatepickerCtrl);

  DatepickerCtrl.$inject = [];

  function DatepickerCtrl() {
    var vm = this;
  }
})();
